import { atomFamily } from "recoil";

export const flowSharedState = atomFamily<{ [key: string]: string }, string>({
  key: "flowSharedState",
  default: {}
});
